import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { HorizontalBarGraph, VerticalBarGraph } from '../bar-graph';
import { getStockPrice } from '@os/cloudquote';
import { calcChange, formatNumber } from '../../lib/util';
import { getGoodPrevClose } from '../../lib/util-stock-price';
import style from './style';

export const INTL_NS = 'sector-performance';

export default class SectorPerformance extends Component {
	componentWillMount() {
		getStockPrice(
			['MSECTOR1','MSECTOR2','MSECTOR3','MSECTOR4','MSECTOR5','MSECTOR6','MSECTOR7','MSECTOR8','MSECTOR9']
		)
			.then((data) => this.setState({ data }));
	}

	render({}, { data }) {
		if (!data || !data.rows) return (
			<div class={style['sector-performance']} />
		);

		let bars = [
			{ barLabel: <Text id={`${INTL_NS}.materials`} /> },
			{ barLabel: <Text id={`${INTL_NS}.conglomerates`} /> },
			{ barLabel: <Text id={`${INTL_NS}.consumer`} /> },
			{ barLabel: <Text id={`${INTL_NS}.financial`} /> },
			{ barLabel: <Text id={`${INTL_NS}.healthcare`} /> },
			{ barLabel: <Text id={`${INTL_NS}.industrial`} /> },
			{ barLabel: <Text id={`${INTL_NS}.services`} /> },
			{ barLabel: <Text id={`${INTL_NS}.technology`} /> },
			{ barLabel: <Text id={`${INTL_NS}.utilities`} /> }
		];
		let min = -1, max = 1;
		for (let i = 0; i < data.rows.length; i++) {
			let row = data.rows[i];
			let goodPrevClose = getGoodPrevClose(row);
			let change = bars[i].change = calcChange(row.Price, goodPrevClose);
			min = change.percent > min ? min : change.percent;
			max = change.percent < max ? max : change.percent;
		}
		let extra = (max - min) * .05;
		min -= extra;
		max += extra;

		for (let i=0; i<bars.length; i++) {
			let bar = bars[i];
			bar.value = bar.change ? (bar.change.percent - min) / (max - min) : 'N/A';
			bar.className = bar.change ? bar.change.class : '';
			bar.valLabel = bar.change ? formatNumber(bar.change.percent, { Decimals: 2, Default: '', Plus: true, Suffix: '%' }) : 'N/A';
		}

		bars.sort( (a,b) => b.value - a.value);

		return (
			<div class={style['sector-performance']}>
				<div class="vert-graph">
					<VerticalBarGraph {...{ bars, width: 500, height: 150, padding: 5 }} />
				</div>
				<div class="horiz-graph">
					<HorizontalBarGraph {...{ bars, width: 250, height: 200, labelPos: 'left', labelWidth: 70 }} />
				</div>
			</div>
		);
	}
}
